import { useMemo } from 'react';
import { useLocation } from 'src/utils/Hooks';
import { useMainEntityId, useMainEntityType, useRetailerId, useTimePeriods } from 'src/utils/Hooks/reduxSelectors';
import { useBeaconFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBeaconFilters';

export const useQueryKey = (chartName: string): string => {
  const { pathname, search } = useLocation();
  const { mainTimePeriod, comparisonTimePeriod } = useTimePeriods();
  const retailerId = useRetailerId();
  const entityType = useMainEntityType();
  const entityId = useMainEntityId();
  const { appFilters } = useBeaconFilters();

  return useMemo(() => {
    const keyParts = {
      entityId,
      entityType,
      retailerId,
      mainPeriod: `${mainTimePeriod.startWeek}-${mainTimePeriod.endWeek}`,
      comparisonPeriod: `${comparisonTimePeriod.startWeek}-${comparisonTimePeriod.endWeek}`,
      filters: appFilters ? JSON.stringify(appFilters) : {},
      location: `${pathname}${search}`,
      chartName
    };

    // Create a deterministic string from the key parts
    const keyString = JSON.stringify(keyParts);
    // TODO: Decide if we want to hash the key string or not
    return keyString.replace(/\s+/g, '');
  }, [
    entityId,
    entityType,
    retailerId,
    mainTimePeriod.startWeek,
    mainTimePeriod.endWeek,
    comparisonTimePeriod.startWeek,
    comparisonTimePeriod.endWeek,
    appFilters,
    pathname,
    search,
    chartName
  ]);
};
